(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mosaic-collage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const blocks = document.querySelectorAll(".mosiacBlock");
  let currentIndex = null;

  function createOverlay() {
    const overlay = document.createElement("div");
    overlay.className = "overlay";
    overlay.style.display = "block"; // Ensure the overlay is visible
    overlay.addEventListener("click", closeExpandedImage); // Close image on overlay click
    return overlay;
  }

  function createArrow(direction) {
    const arrow = document.createElement("div");
    arrow.className = `arrow arrow-${direction}`;
    arrow.innerHTML = direction === "left" ? "&larr;" : "&rarr;";
    return arrow;
  }

  function createCloseButton() {
    const closeButton = document.createElement("div");
    closeButton.className = "close-button";
    closeButton.innerHTML = "&times;";
    closeButton.addEventListener("click", closeExpandedImage); // Close image on close button click
    return closeButton;
  }

  function closeExpandedImage() {
    const expandedImage = document.querySelector(".collageImage.expanded");
    if (expandedImage) {
      expandedImage.classList.remove("expanded");
    }
    document.querySelectorAll(".overlay, .arrow, .close-button").forEach(el => el.remove());
  }

  function showImage(imageIndex) {
    // Remove expanded class from all images
    blocks.forEach(b => b.querySelector(".collageImage").classList.remove("expanded"));

    // Add expanded class to the selected image
    const block = blocks[imageIndex];
    const image = block.querySelector(".collageImage");
    image.classList.add("expanded");

    // Update currentIndex
    currentIndex = imageIndex;

    // Remove any existing overlay, arrows, and close button
    document.querySelectorAll(".overlay, .arrow, .close-button").forEach(el => el.remove());

    // Create and insert overlay
    const overlay = createOverlay();
    document.body.appendChild(overlay);

    // Add navigation arrows
    const leftArrow = createArrow("left");
    const rightArrow = createArrow("right");

    leftArrow.addEventListener("click", function(event) {
      event.stopPropagation(); // Prevents block click event from firing
      showImage((currentIndex - 1 + blocks.length) % blocks.length);
    });

    rightArrow.addEventListener("click", function(event) {
      event.stopPropagation(); // Prevents block click event from firing
      showImage((currentIndex + 1) % blocks.length);
    });

    image.parentNode.appendChild(leftArrow);
    image.parentNode.appendChild(rightArrow);

    // Add close button
    const closeButton = createCloseButton();
    image.parentNode.appendChild(closeButton);
  }

  blocks.forEach((block, index) => {
    block.addEventListener("click", function() {
      if (currentIndex !== index) {
        showImage(index);
      }
    });
  });
});



  } catch(e) { console.error(e); }
})();
})();
